import React from "react";
import MainContent from "../../layouts/maincontent/MainContent";
import { useContext, useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import ElectronicPayment from "../../components/electronicPayment/ElectronicPayment";
import styleAddNewTaxDeclaration from "../taxDeclaration/addNewTaxDeclaration/AddNewTaxDeclaration.module.css";
import { useNavigate } from "react-router-dom";
import { get } from "../../adapters/xhr/api";

function AddNewElectronicPayment() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.phone_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section
          className={`${styleAddNewTaxDeclaration["section-content"]} section-content`}
        >
          <div
            className={`${styleAddNewTaxDeclaration.container} container pt-5`}
          >
            <div
              className={`${styleAddNewTaxDeclaration["card-box"]} card-box`}
            >
              <div
                className={`${styleAddNewTaxDeclaration["header-all-btns"]} header-all-btns`}
              ></div>
              <div className={`${styleAddNewTaxDeclaration.title} title`}>
                <h3>بيانات الدفع الإلكترونى </h3>
              </div>
              <div
                className={`${styleAddNewTaxDeclaration["box-content"]} box-content`}
              >
                <ElectronicPayment />
              </div>
            </div>
          </div>
        </section>
      )}
    </MainContent>
  );
}

export default AddNewElectronicPayment;
